import { put } from 'redux-saga/effects'
import importer from 'common/importer'
/* ACTIONS */
const UserActions = importer('Stores/Users/Actions')
/* ENDPOINT */
const { loginWithEmail } = importer('APIs/users', null)

export default function * main ({ oldId, password, newId }) {
  try {
    yield put(UserActions.emailLoginLoading())
    const response = yield loginWithEmail(oldId, password, newId)
    if (response && response.status === 201) {
      yield put(UserActions.emailLoginSuccess(response))
    } else {
      yield put(UserActions.emailLoginFailure(response))
    }
  } catch (error) {
    yield put(UserActions.emailLoginFailure(error))
  }
}
